import { RootState } from '@/store'

export default function selectUserHasMadePlanSelection(state: RootState) {
  return state.plans.selectedPlan || state.user.user?.profile?.is_plan_pending
}
